<template>
  <div class="icon">
    <svg width="40px" height="40px" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg"
         xmlns:xlink="http://www.w3.org/1999/xlink">
      <rect id="Rectangle" fill="currentColor" x="8" y="14" width="14" height="2" rx="1"></rect>
      <rect id="Rectangle" fill="currentColor" x="8" y="9" width="14" height="2" rx="1"></rect>
      <rect id="Rectangle" fill="currentColor" x="15" y="19" width="7" height="2" rx="1"></rect>
      <circle id="Oval" stroke="currentColor" stroke-width="1.5" cx="15" cy="15" r="14.25" fill="none"></circle>
    </svg>
  </div>
</template>

<script>
export default {
  name: "MobileMenuHamburgerIcon"
}
</script>
